module.exports = __webpack_public_path__ + "assets/img/quality.32e33760.png";